import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import TableLoader from "../../../Loader/admin/TableLoader";
import { useGetVideosForAssignAssignmentQuery } from "../../../redux/features/video/videoApi";
import Error from "../../ui/Error";
import NotFound from "../../ui/NotFound";
import AssignmentForm from "./AssignmentForm";

export default function AssignmentModal({ handleOut }) {
    const { data: videos, isLoading, isError } = useGetVideosForAssignAssignmentQuery(undefined, {
        refetchOnMountOrArgChange: true
    });
    const isEdit = useSelector(state => state.edit?.isEdit);

    //  decide what to render
    let content = null;
    if (isLoading) { content = <TableLoader /> }
    else if (!isLoading && isError) { content = <Error isPadding={true} /> }
    else if (!isLoading && !isError && !videos?.length) {
        content = <NotFound message={"No video available for assign"} isPadding />
    }
    else if (!isLoading && !isError && videos?.length) {



        content = <AssignmentForm handleOut={handleOut} videos={videos} />
    }

    return (
        <div>
            <div className="w-full p-6 flex justify-between items-center">
                <div className='text-2xl font-bold text-cyan'>
                    {isEdit ? "Edit Assignment" : "ADD ASSIGNMENT"}
                </div>
                <div onClick={handleOut} className='p-2 cursor-pointer'><MdCancel /></div>
            </div>
            {content}
        </div>
    )
};